<div class="widget-container" *ngIf="showData; else noData">
	<div class="scores-wrapper"> 
		<div class="score-card" *ngFor="let score of scoreConfigs">
			
			<div class="title">
				<strong>{{ score.titleKey | translate }}</strong> <app-help-tooltip *ngIf="showTooltip" [field]="score.tooltip"></app-help-tooltip>
			</div>

			<svg width="180" height="180">
				<circle cx="90" cy="90" r="70" class="bg"></circle>

				<circle
					cx="90"
					cy="90"
					r="70"
					class="progress"
					[style.stroke]="score.color"
					[style.stroke-dasharray]="circumference"
					[style.stroke-dashoffset]="score.dashOffset">
				</circle>

				<text x="50%" y="50%" text-anchor="middle" dy=".3em">
					{{ score.value > score.maxValue ?  score.maxValue : score.value }}%
				</text>
			</svg>
			<div class="status">
				<span class="status-badge" [style.backgroundColor]="score.color">
					{{ score.status }}
				</span>
			</div>
		</div>
	</div>
</div>

<ng-template #noData>
	<div class="mt-4 pl-3 pr-3">
		<div class="alert alert-info">
		{{ 'g.no_data_to_show' | translate }}
		</div>
	</div>
</ng-template>